<template lang="pug">
.card_borderless
  .card_title.flex_h.justify-content-start.align-items-center(@click="expand")
    img(:src="info.img")
    h4.i_mt_1.i_mt_sm_0.i_ml_4 {{ info.title }}
    svg-icon.d-md-none(
      iconClass="arrow_bottom_g",
      className="arrow_bottom_g",
      :class="{ expand: isExpand }"
    )
  .card_title_cover.d-none.d-md-block
  .card_expand_content(:class="{ expand: isExpand }")
    p.i_body_l.i_mt_2(v-html="info.description")
</template>

<script>
export default {
  name: "Card",
  props: {
    info: Object,
  },
  data() {
    return {
      isExpand: false,
    };
  },
  methods: {
    expand() {
      this.isExpand = !this.isExpand;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/social_responsibility/card";
</style>
